import _ from 'lodash'
import * as service from '../services'

export const INITIAL_FORM_STATE = {
  email: '',
  password: '',
}

export const OTHERS_STATE = {
  enfermOtra: '',
  enfUbicOtra: '',
  plgOtras: '',
  plgUbicOtros: '',
  probFisicosOtros: '',
  riesgoOtros: '',
  recomOtros: '',
}

function getListChangeLogForFeature(metafeatures, values, lnglat) {
  let objToCreation
  _.forEach(metafeatures, object => {
    let currentValue = _.trim(values[object.key])
    if (_.includes(['longX', 'latY'], object.key))
      currentValue = object.key === 'longX' ? lnglat[0] : lnglat[1]

    if (Boolean(currentValue)) {
      let newObj = {}
      newObj[object.key] = {
        id: object.id_mc,
        value: currentValue,
        verified: null,
      }
      objToCreation = { ...objToCreation, ...newObj }
    }
  })
  return objToCreation
}

function getListToGeneralCondition(stateInitial, temporal, values) {
  let objToCreation
  const RIESGOS_OTROS = 91
  const OTHERS_ELEMENTS = [86, 87, 88, 89, 90, 91, 92]
  const list1 = _.filter(temporal, o => _.includes([1, 7], o.category))
  const list2 = _.filter(temporal, o => !_.includes([1, 7], o.category))

  _.forEach(list1, object => {
    const currentId = values[object.name]
    if (currentId) {
      // NO CHANGE THE SIMPLE OPERATOR != TO MODE EXTRICT !==
      if (object.initvalue != currentId) {
        let newObj = {}
        if (RIESGOS_OTROS === object.typecategory)
          newObj[object.name] = {
            categorytype: object.typecategory,
            value: currentId,
          }
        else
          newObj[object.name] = {
            categorytype: parseInt(currentId, 10),
            beforeValue: object.initvalue,
          }
        objToCreation = { ...objToCreation, ...newObj }
      }
    }
  })

  _.forEach(list2, object => {
    const currentTypeCategory = object.typecategory
    if (!_.some(stateInitial, ['typecategory', currentTypeCategory])) {
      let newObj = {}
      newObj[object.name] = { categorytype: currentTypeCategory, value: object.initvalue }
      objToCreation = { ...objToCreation, ...newObj }
    } else {
      if (_.includes(OTHERS_ELEMENTS, currentTypeCategory)) {
        const initial = _.find(stateInitial, ['typecategory', currentTypeCategory])
        if (initial.initvalue !== object.initvalue) {
          let newObj = {}
          newObj[object.name] = {
            categorytype: currentTypeCategory,
            value: object.initvalue,
          }
          objToCreation = { ...objToCreation, ...newObj }
        }
      }
    }
  })
  return objToCreation
}

async function addToDatabase(id, listInconveToStored, token) {
  if (!listInconveToStored || !id) return { stored: null }
  const resUpdateInconv = await service.createAndUpdateInconvenienceLog(
    id,
    listInconveToStored,
    token
  )
  if (_.some(resUpdateInconv.actions, ['typeActions', 'Not created']))
    return {
      stored: false,
      message: 'Algún elemento falló al guardarse. Inténtelo nuevamente.',
    }
  return { stored: true }
}

async function addFeaturesToBD(id, listFeatureToStored, token) {
  if (!listFeatureToStored || !id) return { stored: null }
  const responseFeatures = await service.createFeaturesByKey(
    id,
    listFeatureToStored,
    token
  )
  if (_.some(responseFeatures.actions, ['typeAction', 'Not Created']))
    return {
      stored: false,
      message: 'Algún elemento falló al guardarse. Inténtelo nuevamente.',
    }
  return { stored: true }
}

function getListTreeIdentity(values, groupsFields) {
  const { specieField, siteField, siteAcronym, sectionField, pseudonymField } =
    groupsFields
  const { error: errPseudonym, selected: selectedPs } = pseudonymField
  const { parish_, typeSite_, alive_, treeVerified_, recorded_, commit_ } = values

  const aliveINT = parseInt(alive_, 10)
  const treeVerifiedINT = parseInt(treeVerified_, 10)

  function getFieldsTreeTable() {
    return {
      recorded: recorded_,
      specieId: parseInt(specieField.selected.id, 10),
      siteId: null,
      commit: commit_,
      treeVerified: Boolean(treeVerifiedINT),
      alive: Boolean(aliveINT),
      // photo: null,
    }
  }

  function getFieldsSiteTable() {
    return {
      siteName: siteField.selected,
      typeSite: typeSite_,
      section: sectionField.selected,
      siteAcronym: siteAcronym.selected,
      parishId: parseInt(parish_, 10),
    }
  }

  function getFieldsPseudonymTable() {
    return { new: !errPseudonym ? [...selectedPs] : [] }
  }

  return [getFieldsSiteTable(), getFieldsTreeTable(), getFieldsPseudonymTable()]
}

async function createTreeTable(onlySiteTable, onlyTreeTable, token) {
  try {
    const existElemTreeTable = Object.keys(onlySiteTable).length
    if (!existElemTreeTable) return { stored: null }
    const createdSiteResponse = await service.createSiteTable(onlySiteTable, token)
    // If is 'warning' means previously existed. Update 'siteId' in tree table.
    if (_.includes(['warning', 'creation'], createdSiteResponse.typeAction)) {
      const data = {
        ...onlyTreeTable,
        acronym: onlySiteTable.siteAcronym,
        siteId: createdSiteResponse.id,
        token,
      }

      const createdTree = await service.createTreeTable(data)

      if (createdTree?.action !== 'created')
        return {
          stored: false,
          message: createdTree.message,
        }
      return { stored: true, treeId: createdTree?.tree }
    } else {
      if (_.includes(['notCreated'], createdSiteResponse.typeAction))
        return {
          stored: false,
          message: createdSiteResponse.message,
        }
      return {
        stored: false,
        message: 'Posible actualización fallida. Inténtelo nuevamente.',
      }
    }
  } catch (err) {
    console.log('Error', err)
  }
}

async function savePseudonym(pseudonyms, scientificName, token) {
  if (!pseudonyms.length) return { stored: null }
  const data = _.map(pseudonyms, obj => ({
    nombreComun: obj.name,
    nombreCientifico: scientificName,
  }))
  const response = await service.createPseudonyms(data, token)
  if (Array.isArray(response)) {
    if (_.every(response, ['typeAction', 'creation'])) return { stored: true }
    else {
      const notCreated = _.filter(response, ['typeAction', 'notCreated'])
      const activePseudonym = _.filter(notCreated, obj => Boolean(obj.id))
      if (activePseudonym.length) {
        const dataForActive = _.map(activePseudonym, 'id')
        const responseActivePseudonym = await service.activePseudonymsOfSpecie(
          dataForActive,
          token
        )
        if (Array.isArray(responseActivePseudonym)) {
          if (_.every(responseActivePseudonym, ['typeAction', 'update']))
            return { stored: true }
        }
      }
    }
  }
  return {
    stored: false,
    message: 'Posible actualización fallida. Inténtelo nuevamente.',
  }
}

export async function handleCreationFormik(
  values,
  temporal,
  stateInitial,
  groupsFields,
  token,
  lnglat
) {
  const mtFeature = await service.getMetaFeaturesAll()
  const { res: metafeatures } = mtFeature
  const { label: scientificName } = groupsFields.specieField.selected

  if (!metafeatures)
    return { stored: false, message: 'Falló conexión MetaFeatures', log: mtFeature }

  const listGeneralToStored = getListTreeIdentity(values, groupsFields)
  const listFeatureToStored = getListChangeLogForFeature(metafeatures, values, lnglat)
  const listInconveToStored = getListToGeneralCondition(stateInitial, temporal, values)

  let resultSave
  const respoCreatedTree = await createTreeTable(
    listGeneralToStored[0],
    listGeneralToStored[1],
    token
  )
  const respoSavePsdnym = await savePseudonym(
    listGeneralToStored[2].new,
    scientificName,
    token
  )
  const respAddFeatures = await addFeaturesToBD(
    respoCreatedTree.treeId,
    listFeatureToStored,
    token
  )
  const respAddInconven = await addToDatabase(
    respoCreatedTree.treeId,
    listInconveToStored,
    token
  )
  resultSave = [respoCreatedTree, respoSavePsdnym, respAddFeatures, respAddInconven]

  if (_.every(resultSave, ['stored', null]))
    return { stored: false, message: 'No se registraron cambios' }
  if (_.some(resultSave, ['stored', false])) return _.find(resultSave, ['stored', false])
  return { stored: true, treeId: respoCreatedTree.treeId }
}
